import { Paragraph } from '@almbrand/paragraph';
import { SystemIcons } from '@almbrand/systemicons';
import { BasketThemeName } from '../Basket.types';
import { BasketTile } from '../BasketTile';
import styles from './BasketAddMoreCard.module.scss';

interface BasketAddMoreCardProps {
	themeName: BasketThemeName;
	onClick?: () => void;
	ariaLabel?: string;
	element?: 'li' | 'article'; // use 'li' when rendered inside list and 'article' if rendered stand-alone
	text?: {
		title?: string;
		subtitle?: string;
		ariaLabel?: string;
	};
}

export type BasketAddMoreCardText = NonNullable<BasketAddMoreCardProps['text']>;

export const BasketAddMoreCard: React.FC<BasketAddMoreCardProps> = ({
	themeName,
	onClick,
	ariaLabel,
	element,
	text: { title, subtitle, ariaLabel: textAriaLabel } = {},
}) => {
	return (
		<BasketTile
			element={element}
			onClick={onClick}
			ariaLabel={ariaLabel ?? textAriaLabel}
		>
			<div className={styles.BasketAddMoreCard}>
				<div className={styles.BasketAddMoreCard__text}>
					<Paragraph
						className={styles.BasketAddMoreCard__title}
						text={title}
						paragraphType={{
							kind: 'title',
							type: 'standfirst',
						}}
						fontColor='primary'
					/>
					<Paragraph
						className={styles.BasketAddMoreCard__subtitle}
						text={subtitle}
						paragraphType={{
							kind: 'label',
							size: 'default',
						}}
						fontColor='primaryDark'
					/>
				</div>

				<div
					className={styles.BasketAddMoreCard__addButton}
					aria-hidden='true'
				>
					<SystemIcons
						themeName={themeName}
						icon='plus'
						fill='var(--color-primary-4)'
						width={20}
						height={20}
					/>
				</div>
			</div>
		</BasketTile>
	);
};
